'use client'
import { useEffect, useRef, useState } from 'react'

export function QRButton({ url, name, downloadLabel = 'Download PNG' }: {
  url: string
  name: string
  downloadLabel?: string
}) {
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const [dataUrl, setDataUrl] = useState<string | null>(null)

  useEffect(() => {
    import('qrcode').then(QR => {
      QR.toDataURL(url, {
        width: 200,
        margin: 2,
        color: { dark: '#211C16', light: '#FFFFFF' },
      }).then(du => setDataUrl(du))
    })
  }, [url])

  function download() {
    if (!dataUrl) return
    const a = document.createElement('a')
    a.href = dataUrl
    a.download = `goris-${name.toLowerCase().replace(/\s+/g, '-')}-qr.png`
    a.click()
  }

  return (
    <div className="qr-inner">
      <div className="qr-code-wrap">
        {dataUrl ? (
          <img src={dataUrl} alt={`QR code for ${name}`} width={160} height={160} />
        ) : (
          <div className="qr-placeholder" />
        )}
      </div>
      <div className="qr-info">
        <div className="qr-url">{url}</div>
        {dataUrl && (
          <button type="button" className="qr-download" onClick={download}>
            {downloadLabel}
          </button>
        )}
      </div>
    </div>
  )
}
